import "core-js/modules/es.array.concat.js";
import ThemePicker from '@/components/ThemePicker';
export default {
  name: 'Settings',
  components: {
    ThemePicker: ThemePicker
  },
  data: function data() {
    return {
      theme: this.$store.state.settings.theme,
      sideTheme: this.$store.state.settings.sideTheme
    };
  },
  computed: {
    fixedHeader: {
      get: function get() {
        return this.$store.state.settings.fixedHeader;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        });
      }
    },
    topNav: {
      get: function get() {
        return this.$store.state.settings.topNav;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'topNav',
          value: val
        });
        if (!val) {
          this.$store.commit('permission/SET_SIDEBAR_ROUTERS', this.$store.state.permission.defaultRoutes);
        }
      }
    },
    tagsView: {
      get: function get() {
        return this.$store.state.settings.tagsView;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        });
      }
    },
    sidebarLogo: {
      get: function get() {
        return this.$store.state.settings.sidebarLogo;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        });
      }
    },
    dynamicTitle: {
      get: function get() {
        return this.$store.state.settings.dynamicTitle;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'dynamicTitle',
          value: val
        });
      }
    }
  },
  methods: {
    themeChange: function themeChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      });
      this.theme = val;
    },
    handleTheme: function handleTheme(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'sideTheme',
        value: val
      });
      this.sideTheme = val;
    },
    saveSetting: function saveSetting() {
      var loading = this.$loading({
        lock: true,
        fullscreen: false,
        text: '正在保存到本地，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      localStorage.setItem('layout-setting', "{\n            \"topNav\":".concat(this.topNav, ",\n            \"tagsView\":").concat(this.tagsView, ",\n            \"fixedHeader\":").concat(this.fixedHeader, ",\n            \"sidebarLogo\":").concat(this.sidebarLogo, ",\n            \"dynamicTitle\":").concat(this.dynamicTitle, ",\n            \"sideTheme\":\"").concat(this.sideTheme, "\",\n            \"theme\":\"").concat(this.theme, "\"\n          }"));
      setTimeout(loading.close(), 1000);
    },
    resetSetting: function resetSetting() {
      this.$loading({
        lock: true,
        fullscreen: false,
        text: '正在清除设置缓存并刷新，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      localStorage.removeItem('layout-setting');
      // eslint-disable-next-line no-implied-eval
      setTimeout('window.location.reload()', 1000);
    }
  }
};